import team1 from "../assets/img/team/team-1.jpg";
import team2 from "../assets/img/team/team-2.jpg";
import team3 from "../assets/img/team/team-3.jpg";
import team4 from "../assets/img/team/team-4.jpg";
import team5 from "../assets/img/team/member-1.jpg";
import team6 from "../assets/img/team/member-2.jpg";
import team7 from "../assets/img/team/member-3.jpg";
import team8 from "../assets/img/team/member-4.jpg";

const teamData = [
    {
        id: 'amelia-clover',
        image: team1,
        position: 'Project Manager',
        name: 'Amelia Clover',
        category: 'founder',
        social_link: [
            { link: 'https://www.facebook.com', target: '_blank', icon: <i className="fab fa-facebook-f"></i> },
            { link: 'https://twitter.com', target: '_blank', icon: <i className="fa-brands fa-x-twitter"></i> },
            { link: 'https://www.linkedin.com', target: '_blank', icon: <i className="fab fa-behance"></i> },
        ],
    },
    {
        id: 'julian-wyat',
        image: team2,
        position: 'Site Engineer',
        name: 'Julian Wyat',
        category: 'writer',
        social_link: [
            { link: 'https://www.facebook.com', target: '_blank', icon: <i className="fab fa-facebook-f"></i> },
            { link: 'https://twitter.com', target: '_blank', icon: <i className="fa-brands fa-x-twitter"></i> },
            { link: 'https://www.linkedin.com', target: '_blank', icon: <i className="fab fa-behance"></i> },
        ],
    },
    {
        id: 'guy-hawkins',
        image: team3,
        position: 'Safety Officer',
        name: 'Guy Hawkins',
        category: 'founder',
        social_link: [
            { link: 'https://www.facebook.com', target: '_blank', icon: <i className="fab fa-facebook-f"></i> },
            { link: 'https://twitter.com', target: '_blank', icon: <i className="fa-brands fa-x-twitter"></i> },
            { link: 'https://www.linkedin.com', target: '_blank', icon: <i className="fab fa-behance"></i> },
        ],
    },
    {
        id: 'archer-graham',
        image: team4,
        position: 'General Laborer',
        name: 'Archer Graham',
        category: 'writer',
        social_link: [
            { link: 'https://www.facebook.com', target: '_blank', icon: <i className="fab fa-facebook-f"></i> },
            { link: 'https://twitter.com', target: '_blank', icon: <i className="fa-brands fa-x-twitter"></i> },
            { link: 'https://www.linkedin.com', target: '_blank', icon: <i className="fab fa-behance"></i> },
        ],
    },
    {
        id: 'alan-dosan',
        image: team5,
        position: 'Lead Architect',
        name: 'Alan Dosan',
        category: 'manager',
        social_link: [
            { link: 'https://www.facebook.com', target: '_blank', icon: <i className="fab fa-facebook-f"></i> },
            { link: 'https://twitter.com', target: '_blank', icon: <i className="fa-brands fa-x-twitter"></i> },
            { link: 'https://www.linkedin.com', target: '_blank', icon: <i className="fab fa-behance"></i> },
        ],
    },
    {
        id: 'sarah-johnson',
        image: team6,
        position: 'General Laborer',
        name: 'Sarah Johnson',
        category: 'designer',
        social_link: [
            { link: 'https://www.facebook.com', target: '_blank', icon: <i className="fab fa-facebook-f"></i> },
            { link: 'https://twitter.com', target: '_blank', icon: <i className="fa-brands fa-x-twitter"></i> },
            { link: 'https://www.linkedin.com', target: '_blank', icon: <i className="fab fa-behance"></i> },
        ],
    },
    {
        id: 'derya-kurtulus',
        image: team7,
        position: 'Safety Inspector',
        name: 'Derya Kurtulus',
        category: 'inspector',
        social_link: [
            { link: 'https://www.facebook.com', target: '_blank', icon: <i className="fab fa-facebook-f"></i> },
            { link: 'https://twitter.com', target: '_blank', icon: <i className="fa-brands fa-x-twitter"></i> },
            { link: 'https://www.linkedin.com', target: '_blank', icon: <i className="fab fa-behance"></i> },
        ],
    },
    {
        id: 'steve-rhodes',
        image: team8,
        position: 'Civil Engineer',
        name: 'Steve Rhodes',
        category: 'engineer',
        social_link: [
            { link: 'https://www.facebook.com', target: '_blank', icon: <i className="fab fa-facebook-f"></i> },
            { link: 'https://twitter.com', target: '_blank', icon: <i className="fa-brands fa-x-twitter"></i> },
            { link: 'https://www.linkedin.com', target: '_blank', icon: <i className="fab fa-behance"></i> },
        ],
    },
];

export default teamData;